import React from 'react';
import {Link, browserHistory} from 'react-router';
import './profile_navbar.less';
import MediaQuery from 'react-responsive';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import ProfileNavBarDektop from './profile_navbar_desktop';
import ProfileNavBarMobile from './profile_navbar_mobile';


class ProfileNavBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {props, state} = this;
        return (
            <div className="profile-nav-bar-container">
              <MediaQuery query='(min-width: 768px)'>
                <ProfileNavBarDektop pathname={props.pathname} userData={props.userData} />
              </MediaQuery>
              <MediaQuery query='(max-width: 767px)'>
                <ProfileNavBarMobile pathname={props.pathname} userData={props.userData}/>
              </MediaQuery>
            </div>
        )
    }
}

ProfileNavBar.propTypes = {
  pathname: React.PropTypes.string.isRequired
};


ProfileNavBar = connect((state) => {
  return {
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch)
  }
})(ProfileNavBar);

module.exports = ProfileNavBar;



// WEBPACK FOOTER //
// app/profile/profile_navbar/profile_navbar.jsx